import { render, staticRenderFns } from "./relatorio-pets-unidade.vue?vue&type=template&id=5dec8926"
import script from "./relatorio-pets-unidade.vue?vue&type=script&lang=js"
export * from "./relatorio-pets-unidade.vue?vue&type=script&lang=js"
import style0 from "./relatorio-pets-unidade.vue?vue&type=style&index=0&id=5dec8926&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports